<template lang="html">
  <cw-basic-cell class="cw-switch-cell">
    <div slot="left-fill-area">
      <p v-if="title" :class="titleClasses">{{ title }}</p>
    </div>
    <div slot="right-area-2">
      <cw-switch :is-on="switchOn" @update:isOn="handleChange"></cw-switch>
    </div>
  </cw-basic-cell>
</template>

<script>
export default {
  name: 'cw-switch-cell',
  props: {
    title: {
      type: String,
      required: false,
    },
    titleClasses: {
      type: Array,
      required: false,
      default: () => ['title', 'is-size-4', 'font-light'],
    },
    switchOn: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    handleChange(newVal) {
      this.$emit('update:switchOn', newVal);
    },
  },
};
</script>

<style lang="" scoped></style>
